import { render } from "./list-item-image.vue?vue&type=template&id=41d88c98&scoped=true"
import script from "./list-item-image.vue?vue&type=script&lang=js"
export * from "./list-item-image.vue?vue&type=script&lang=js"

import "./list-item-image.vue?vue&type=style&index=0&id=41d88c98&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d88c98"]])

export default __exports__